import { ANNOTATION_VALUE } from "@/constants/annotation-values"
import {
  deriveYesNoString,
  getMetricColor,
  getMetricColorForMetric,
  getMetricTextColorClass,
  type YesNoLabels,
} from "@/metrics/metric-display"
import clsx from "clsx"

import type {
  MetricRecordData,
  TargetCondition,
} from "@/types/metrics/contracts"
import type { RunMetricOutput } from "@/types/RunMetricOutput"

const DEFAULT_DISPLAY: Record<"YES" | "NO" | "UNKNOWN", string> = {
  [ANNOTATION_VALUE.YES]: "Yes",
  [ANNOTATION_VALUE.NO]: "No",
  [ANNOTATION_VALUE.UNKNOWN]: "N/A",
}

export const SingleBinary = ({
  mo,
  targetCondition,
  labels,
  metric,
}: {
  mo: RunMetricOutput
  targetCondition?: TargetCondition
  labels?: YesNoLabels
  metric?: MetricRecordData
}) => {
  const fv = mo.float_value
  if (fv != null && fv !== 0 && fv !== 1 && fv !== -1) {
    return (
      <div className="text-sm text-coval-danger-text">
        Invalid binary value: {fv}
      </div>
    )
  }
  const valueStr = deriveYesNoString(mo)
  const color = metric
    ? getMetricColorForMetric(valueStr, metric)
    : getMetricColor(valueStr, targetCondition)
  const valueClassName = getMetricTextColorClass(color)
  const display = {
    YES: labels?.yes ?? DEFAULT_DISPLAY.YES,
    NO: labels?.no ?? DEFAULT_DISPLAY.NO,
    UNKNOWN: labels?.unknown ?? DEFAULT_DISPLAY.UNKNOWN,
  }
  return (
    <div className={clsx("text-2xl font-semibold", valueClassName)}>
      {display[valueStr]}
      {color === "danger" && <span className="sr-only">(below target)</span>}
    </div>
  )
}
